import { useEphattaMutation } from "@hooks/utils"
import { useCustomerPaymentMethodService } from "./useCustomerPaymentMethodService"

export const useCustomerPaymentMethodSave = () => {
    const services = useCustomerPaymentMethodService()
  return useEphattaMutation( 
    (cardId: string) => services.save(cardId)
   )
}
